import { render, staticRenderFns } from "./EntityDicts.vue?vue&type=template&id=c078946e&scoped=true"
import script from "./EntityDicts.vue?vue&type=script&lang=js"
export * from "./EntityDicts.vue?vue&type=script&lang=js"
import style0 from "./EntityDicts.vue?vue&type=style&index=0&id=c078946e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c078946e",
  null
  
)

export default component.exports